import { useTabManager, useTabs } from "../../contexts/tab-manager"

const Tabs = () => {
    const tabManager = useTabManager();
    const tabs = useTabs()

    const goto = (id) => tabManager.goto(id);
    const close = (e, id) => {
        e.stopPropagation();
        tabManager.close(id);
    };

    const TabBtn = (tab) => {
        return <div onClick={() => goto(tab.id)} key={tab.id} className={`d-inline-block btn-sm bg-gradient-${tab.active ? 'dark' : 'primary'} text-white p-1 me-2 link`}>
            <span className="text-capitalize">{tab.title} </span>
            <button onClick={(e) => close(e, tab.id)} className="btn btn-outline-danger btn-sm" type="button">
                <i className="fas fa-times"></i>
            </button>
        </div>;
    }
    return <>
        <div className="d-block overflow-auto text-nowrap">
            {tabs.map(tab => TabBtn(tab))}
        </div>
        <div className="flex-grow-1 w-100">
            {tabs.map(t => <iframe key={t.id} src={t.current} title={t.title} className={`h-100 w-100 ${t.active ? '' : 'd-none'}`}></iframe>)}
        </div>
    </>;
}

export default Tabs;